export function operationalActivitySummary(event, translate, exists) {
  const key = `messagesList.internalEvents.types.${event.type}`;
  if (String(event.type).startsWith("ai_operational_") && exists(key)) return translate(key);
  return event.summary || (exists(key) ? translate(key) : event.type);
}
